export enum EMetadataCategory {
    PROFILES = 'profiles',
    TASKS = 'tasks',
    MESSAGES = 'messages'
}
